import type { IPlayer } from '@skillarea/game-layout';
import type { Color } from '@skillarea/game-chess';

import type { TGamePlayer } from '../types';

export interface IChessLayoutPropsInput {
  playerColor: Color;
  player1: TGamePlayer;
  player2: TGamePlayer;
  currentTurn: Color;
  isGameOver: boolean;
}

export interface IChessLayoutPropsResult {
  player1: IPlayer;
  player2: IPlayer;
  activePlayerId: string | null;
}

export function getChessLayoutProps(
  input: IChessLayoutPropsInput,
): IChessLayoutPropsResult {
  const {
    currentTurn,
    isGameOver,
    player1: player1Info,
    player2: player2Info,
    playerColor,
  } = input;

  const player1: IPlayer = {
    id: 'player1',
    name: player1Info.name,
    avatarUrl: player1Info.avatarUrl,
    symbol: playerColor === 'w' ? 'W' : 'B',
  };

  const player2: IPlayer = {
    id: 'player2',
    name: player2Info.name,
    avatarUrl: player2Info.avatarUrl,
    symbol: playerColor === 'w' ? 'B' : 'W',
  };

  const activePlayerId = isGameOver
    ? null
    : currentTurn === 'w'
      ? playerColor === 'w'
        ? 'player1'
        : 'player2'
      : playerColor === 'w'
        ? 'player2'
        : 'player1';

  return { activePlayerId, player1, player2 };
}
